/// <amd-module name="Release/DeploymentsSection/Actions/DeploymentsComponentActionsCreator" />
import { IVssPageContext } from "VSS/Platform/Context";

import {DeploymentsComponentActions} from "Release/DeploymentsSection/Actions/DeploymentsComponentActions";
import {DeploymentsSource} from "Release/DeploymentsSection/DeploymentsSource";
import { IDeploymentsData } from "Release/DeploymentsSection/DeploymentsData";

export class DeploymentsComponentActionsCreator {

    constructor(actions: DeploymentsComponentActions, source: DeploymentsSource) {
        this._actions = actions;
        this._source = source;
    }
    public static getKey(): string {
        return "deployments-section-actionscreator";
    }

    public initializeData(build: any): Promise<void> {
        return new Promise((resolve) => {
            this._source.loadDeploymentsData(build.id).then((deploymentsData: IDeploymentsData) => {
                this._actions.setDeploymentsData.invoke(deploymentsData);
                resolve();
            });
        });
    }

    public incrementRenderIndex(): void {
        this._actions.incrementRenderIndex.invoke(undefined);
    }

    public maximizeRenderIndex(): void {
        this._actions.maximizeRenderIndex.invoke(undefined);
    }

    public resetView(): void {
        this._actions.resetView.invoke(undefined);
    }

    public toggleExpandIssues() {
        this._actions.toggleExpandIssues.invoke(undefined);
    }

    private _actions: DeploymentsComponentActions;
    private _source: DeploymentsSource; 
}
